export default {
    fund: [{
            "title": "某基金经理的下列行为中，违反保守秘密要求的是（　　）。",
            "question": "A. 某一秘密已经被泄露，尽快通知有关部门做出补救措施\nB. 受所在机构委派，与其他同行交流公司内控制度及对行业的看法\nC. 将所在机构官网披露的行业研究报告及投资组合发送给朋友参考\nD. 求职面试时，向面试单位详细介绍之前所在机构的员工激励机制",
            "answer": "D",
            "explain": "本题考查保守秘密的基本要求。保守秘密，要求基金从业人员不得向第三者透露作为秘密的信息，也不得公开尚处于禁止公开期间的信息。具体而言，基金从业人员应当做到以下几点：（1）应当妥善保管并严格保守客户秘密，非经许可不得泄露客户资料和交易信息。且无论是在任职期间还是离职后，均不得泄露任何客户资料和交易信息。（2）不得泄露在执业活动中所获知的各机关方的信息及所属机构的商业秘密更不得用以为自己或他人谋取不正当的利益。（D选项违反保守秘密的要求）（3）不得在执业活动中所获的内商不与应事"
        },
        {
            "title": "关于资产管理行业功能，以下表述错误的是（　　）。",
            "question": "A. 资产管理行业能够促进市场经济体系有效配置资源\nB. 资产管理行业能够对金融资产进行合理定价\nC. 资产管理行业能够使投资融资更加便利\nD. 资产管理行业将资金需求方和提供方连接起来并收取费用，提高了金融市场的交易成本",
            "answer": "D",
            "explain": "本题考查资产管理行业的功能。A选项表述正确，资产管理行业能够为市场经济体系有效配置资源，使有限的资源配置到最有效率的产品和服务部门，提高整个社会经济的效率和生产服务水平。B选项表述正确，资产管理行业能对金融资产进行合理定价，给金融市场提供流动性，降低交易成本(D选项中提高交易成本表述错误)，使金融市场更加健康有效。最终有利于一国经济的发展。C选项表述正确，通过资产管理行业专业的管理活动，能够帮助投资人搜集、处理各种和投资有关的宏观、微观信息、提供各类投资机会，帮助投资者进行投资决策，并提供决策的最佳执行服务，使投资融资更加便利。"
        },
        {
            "title": "关于QDII基金的申购赎回，投资者甲认为，由于境外交易所的开市时间不同，因此QDII基金的申购赎回的开放时间与一般开放式基金不同;投资者乙认为，QDII基金的申购赎回与一般开放式基金相同，在T+1日对申购和赎回申请进行确认。关于两位投资者的观点，下列判断正确的是（　　）。",
            "question": "A. 甲的观点正确，乙的观点错误\nB. 甲、乙的观点都正确\nC. 甲、乙的观点都错误\nD. 甲的观点错误，乙的观点正确",
            "answer": "C",
            "explain": "本题考查QDII基金的申购和赎回。QDII基金的申购和赎回与一般开放式基金的申购和赎回相同点：（1）申购和赎回渠道。（2）申购和赎回的开放时间。（甲说法错误）"
        },
        {
            "title": "关于基金管理公司董事会应履行的风险管理职责，以下表述错误的是（　　）。",
            "question": "A. 授权下设专门委员会履行相应的风险管理和监督职责\nB. 组织实施重大风险的解决方案\nC. 制定公司风险管理战略和风险应对策略\nD. 审议重大事件、重大决策的风险评估意见",
            "answer": "B",
            "explain": "本题考查董事会的风险管理职责。董事会对有效的风险管理承担最终责任，履行的风险管理职责是：（1）确定公司风险管理总体目标，制定公司风险管理战略和风险应对策略(C选项正确)：（2）审议重大事件、重大决策的风险评估意见，审批重大风险的解决方案，批准公司基本风险管理制度(D选项正确)：（3）审议公司风险管理报告；（4）可授权董事会下设的风险管理委员会或其他专门委员会履行相应风险管理和监督职责(A选项正确)。"
        },
        {
            "title": "下列关于货币市场基金偏离度的说法错误的是（　　）。",
            "question": "A. 当影子定价所确定的基金资产净值超过摊余成本法计算的基金资产净值(即产生正偏离)时，表明基金组合中存在浮亏;反之，当存在负偏离时，则基金组合中存在浮盈\nB. 在临时报告中，应披露影子定价与摊余成本法确定的基金资产净值负偏离度绝对值超过0.25%时的信息\nC. 当负偏离度绝对值连续2个交易日超过0.5%时，基金管理人应当采用公允价值估值方法对持有投资组合的账面价值进行调整\nD. 在季度报告的投资组合报告中，应披露报告期内偏离度的绝对值在0.25%-0.5%间的次数",
            "answer": "A",
            "explain": "本题考查货币基金偏离度相关内容。A选项说法错误，当影子定价所确定的基金资产净值超过摊余成本法计算的基金资产净值(即产生正偏离)时，表明基金组合中存在浮盈;反之，当存在负偏离时，则基金组合中存在浮亏。B选项说法正确，在临时报告中，应披露影子定价与摊余成本法确定的基金资产净值负偏离度绝对值超过0.25%时的信息。C选项说法正确，当负偏离度绝对值连续2个交易日超过0.5%时，基金管理人应当采用公允价值估值方法对持有投资组合的账面价值进行调整。"
        },
        {
            "title": "某证券公司的合规人员出于业务需要，对于在公司业务发展中的合规性问题，配合业务部门向公司所在地证监局沟通业务的可行性，以上体现了合规管理基本原则中的（　　）。",
            "question": "A. 协调性原则\nB. 独立性原则\nC. 专业性原则\nD. 客观性原则",
            "answer": "A",
            "explain": "本题考查协调性原则。A选项符合题意，协调性原则是指合规人员应当正确处理与公司其他部门及监管部门的关系，努力形成公司的合规合力，避免内部消耗。B选项不符合题意，独立性原则主要是指合规部门和督察长在基金公司可组织体系中应当有独立地位，合规管理应当独立于其他各项业务经营活动。C选项不符合题意，专业性原则是指合规人员应当熟悉业务制度，了解基金管理人各种业务的运作流程，并准确理解和把握法律法规的规定和变动趋势。D选项不符合题意，客观性原则是指合规人员应当依照相关法规对违规事实进行客观评价，避免出现合规人员自身与业务人员合谋的违规行为。"
        }, {
            "title": "中国证券投资基金业协会章程应由（　　）制定。",
            "question": "A. 中国证券投资基金业协会\nB. 中国证券投资基金业协会会员大会\nC. 中国证券投资基金业协会会员代表大会\nD. 中国证监会",
            "answer": "B",
            "explain": "本题考查中国证券投资基金业协会。基金业协会的权力机构为全体会员组成的会员大会，协议章程由会员大会制定，并报中国证监会备案。"
        },
        {
            "title": "关于基金从业人员职业道德中的客户至上要求，以下表述错误的是（　　）。",
            "question": "A. 应采取措施避免与投资人发生利益冲突\nB. 执业中发现与投资人产生利益冲突时，以投资人利益优先即可，无需向所在机构报告\nC. 不得在不同基金资产之间进行利益输送\nD. 不得从事与投资人利益相冲突的业务",
            "answer": "B",
            "explain": "本题考查客户至上。客户至上是指基金从业人员的执业活动应一切从投资人的根本利益出发，其基本含义有两点一是客户利益优先，二是公平对待客户。这里的“客户”，是指投资人，也即基金份额持有人。客户至上是调整基金从业人员与投资人之间关系的道德规范。A选项表述正确，D选项表述正确，基金从业人员不得从事与投资人利益相冲突的业务。B选项表述错误，在执业过程中遇到自身利益或相关方利益与投资人利益发生冲突时，应以投资人利益优先，并应及时向所在机构报告(而不是无需报告)。"
        },
        {
            "title": "基金管理人合规管理的独立性，应当体现在（　　）等方面独立于内部其他部门。",
            "questions": "I. 体制机制<br>II. 组织架构<br>III. 人员薪酬<br>IV. 管理流程",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查合规独立性。独立性原则是指合规管理应当独立于基金管理人的业务经营活动。合规独立性是指基金管理人的合规管理应当在体制机制、组织架构、人力资源、管理流程等诸多方面独立于内部其他风险部门、业务部门、内部审计部门等。"
        },
        {
            "title": "基金管理公司或基金代售机构出现基金宣传推介材料的违规情形，对其采取的行政监管措施不包括（　　）。",
            "question": "A. 责令基金管理公司进行整改\nB. 对在6个月内出现一次被出具监管警告函仍未整改的基金管理公司，其在分发基金宣传材料前，应当事先将材料报送中国证监会\nC. 对直接负责的基金管理公司高级管理人员采取监管谈话等措施\nD. 对基金公司出具监管警示函",
            "answer": "B",
            "explain": "本题考查违规使用宣传推介材料的行政监管处罚措施。违规使用宣传推介材料的行政监管处罚措施包括：（1）提示基金管理公司或基金代销机构进行改正；（2）对基金管理公司或基金代销机构出具监管警示函(D选项不符合题意)；（3）对在6个月内连续两次(B选项符合题意，是两次而不是一次)被出具监管警示函仍未改正的基金管理公司或基金代销机构，该公司或机构在分发或公布基金宣传推介材料前，应当事先将材料报送中国证监会。基金宣传推介材料自报送中国证监会之日起10日后，方可使用;在上述期限内，中国证监会发现基金宣传推介材料不符合有关规定的，可及时告知该公司或机构进行修改，材料未经修改的，该公司或机构不得使用；"
        },
        {
            "title": "关于投资基金的类别，以下表述正确的包括（　　）。",
            "questions": "I. 按照运作方式，投资基金分为一对一型和一对多型<br>II. 按照法律形式，投资基金分为合伙型和公司型<br>III. 按照资金募集方式，投资基金分为公募型和私募型<br>IV. 按照投资对象，投资基金分为传统型和另类型",
            "question": "A. III、IV\nB. I、II\nC. II、III\nD. I、IV",
            "answer": "A",
            "explain": "本题考查投资基金的分类。投资基金的分类包括：（1）按照资金募集方式:公募基金和私募基金（II项正确）；"
        }, {
            "title": "以下关于基金销售机构编制的公募证券投资基金宣传推介材料中的描述，不符合法律法规规定的是（　　）。",
            "question": "A. 本材料仅载明基金部分信息，敬请投资人查阅基金合同和招募说明书以了解基金的具体情况\nB. 本基金是基金管理人精心为震荡市场投资理财而设计的投资工具，请投资人注意投资风险\nC. 本销售机构保证以上基金信息的真实、准确和完整\nD. 本基金最佳预期年化收益率8%，但本基金属于高风险品种，上述预期存在无法实现的可能",
            "answer": "D",
            "explain": "本题考查基金宣传推介材料的禁止性规定。A选项不符合题意，基金合同和招募说明书中全面说明了基金的详细情况，A选项投资人若想了解基金具体情况，可查阅基金合同和招募说明书，故符合规定。B选项不符合题意，基金宣传推介材料中推介基金的，应当明确提示投资人基金的投资风险，B选项提示投资人注意投资风险，故符合规定。C选项不符合题意，基金销售机构应保证宣传推介材料信息的真实、准确和完整，故符合规定。D选项符合题意，基金宣传推介材料禁止预测基金业绩，D选项预测该基金的收益率为8%，故不符合规定。"
        },
        {
            "title": "对于开放式基金份额赎回所收取的赎回费，应列入基金资产的比例为（　　）。",
            "question": "A. 12%\nB. 25%\nC. 18%\nD. 35%",
            "answer": "B",
            "explain": "本题考查开放式基金申购和赎回的费用。场外赎回可按份额在场外的持有时间分段设置赎回费率;场内赎回为固定赎回费率。赎回费在扣除手续费后，余额不得低于赎回费总额的25%(B选项符合题意),并应当归入基金财产。"
        },
        {
            "title": "随着人们生活水平的大幅度提高，个人资产处置方式的增加，（　　）能够帮助投资者克服单一投资产品或投资方法的困惑。",
            "question": "A. 资产配置教育\nB. 权益保护教育\nC. 投资决策教育\nD. 合规风控教育",
            "answer": "A",
            "explain": "本题考查投资者教育的内容。资产配置教育即指导投资者对个人资产进行科学的计划和控制。随着人们生活水平的大幅度提高，个人财富的逐步积累，投资理财无论在国外还是在国内都越来越为人们所接受。人们对个人资产的处置有很多种方式，进行证券投资只是投资者个人资产配置中的一个方法或环节，投资者的个人财务计划会对其投资决策和策略产生重大影响。因此，许多投资者教育专家都认为投资者教育的范围应超越投资者具体的投资行为，深入整个个人资产配置中，只有这样才能从根本上解决投资者的困惑。"
        },
        {
            "title": "关于开放式基金在募集期内的认购，以下表述正确的是（　　）。",
            "question": "A. 投资者认购申请表被正式受理后可以撤销\nB. 投资者在募集期内可以多次认购基金份额\nC. 投资者在募集期内仅可认购1次基金份额\nD. 投资者在募集期内仅可认购2次基金份额",
            "answer": "B",
            "explain": "本题考查开放式基金的认购步骤。投资者在募集期间内可多次认购基金份额。一般情况下，已正式受理的认购申请不得撤销。故A、C、D说法错误。B选项说法正确。"
        },
        {
            "title": "基金销售机构应制定完善的资金清算流程，资金管理符合（　　）对基金销售结算资金管理的有关要求。",
            "question": "A. 中国证监会\nB. 中国银保监会\nC. 中国证券投资基金业协会\nD. 中国人民银行",
            "answer": "A",
            "explain": "本题考查基金销售业务资格的注册条件。申请注册基金销售业务资格，应当具备下列条件：（1）具有健全的治理结构、完善的内部控制和风险管理制度，并得到有效执行；（2）财务状况良好，运作规范稳定；（3）有与基金销售业务相适应的营业场所、安全防范设施和其他设施；（4）有安全、高效的办理基金发售、申购和赎回等业务的技术设施，且符合中国证监会对基金销售业务信息管理平台的有关要求，基金销售业务的技术系统已与基金管理人、中国证券登记结算公司相应的技术系统进行了联网测试，测试结果符合国家规定的标准；"
        },
        {
            "title": "下列可以担任公开募集基金的基金管理人董事的人员是（　　）。",
            "question": "A. 丁，曾经是某律师事务所律师，因违法行为被吊销执业证书已满五年\nB. 丙，曾经在某证券交易所任职，因违法行为被开除已满五年\nC. 甲，曾经犯有贪污贿赂犯罪，被判处刑罚已满五年。\nD. 乙，曾经担任某公司总经理，该公司因其个人原因经营不善破产清算，但该公司破产清算终结已满五年。",
            "answer": "D",
            "explain": "本题考查对基金管理人从业人员资格的监管。不得担任公开募集基金的基金管理人的董事、监事、高级管理人员和其他从业人员的情形：（1）因犯有贪污贿赂、渎职、侵犯财产罪或者破坏社会主义市场经济秩序罪，被判处刑罚的；（2）对所任职的公司、企业因经营不善破产清算或者因违法被吊销营业执照负有个人责任的董事、监事、厂长、高级管理人员，自该公司、企业破产清算终结或者被吊销营业执照之日起未逾五年的；（3）个人所负债务数额较大，到期未清偿的；（4）因违法行为被开除的基金管理人、基金托管人、证券交易所、证券公司、证券登记结算机构、期货交易所、期货公司及其他机构的从业人员。"
        }, {
            "title": "（　　）是对公司章程规定的内控原则的细化和展开。",
            "question": "A. 内部控制大纲\nB. 内部控制制度\nC. 业务操作手册\nD. 部门业务规章",
            "answer": "A",
            "explain": "本题考查内部控制大纲。A选项符合题意，公司内部控制大纲是对公司章程规定的内控原则的细化和展开，是各项基本管理制度的纲要和总揽。B选项不符合题意，内部控制制度是管理人为保护其资产安全完整，及经营活动符合国家要求，为提高经营效率，防止舞弊，控制风险，而在公司内部采取的一系列相互联系、相互制约的制度和方法。C选项不符合题意，业务操作手册是在基金管理人确定相关业务基础上，对业务的性质种类以及相关的管理规定和操作流程及要求进行明确的说明，是业务人员上岗操作的指南。"
        },
        {
            "title": "某资产管理有限公司为在中国证券投资基金业协会登记的私募基金管理人，其制度体系中包括下列制度，其中与《私募投资基金监督管理暂行办法》中投资运作行为规范相关的制度为（　　）。",
            "questions": "I. 《公平交易管理办法》<br>II. 《利益冲突防范管理办法》<br>III. 《内幕交易防控管理办法》<br>IV. 《员工证券投资管理办法》",
            "question": "A. I、IV\nB. I、II、III\nC. I、II、IV\nD. I、III、IV",
            "answer": "B",
            "explain": "本题考查《私募投资基金监督管理暂行办法》。I项符合题意，《公平交易管理办法》是为了加强公司投资管理，保障投资人利益，避免利益冲突，防范利益输送，保证交易公平制定的办法。"
        },
        {
            "title": "以下不属于基金上市交易公告书主要披露事项的是（　　）。",
            "question": "A. 基金投资组合报告\nB. 基金概况\nC. 持有人结构及前10名持有人\nD. 基金公司内部监察报告",
            "answer": "D",
            "explain": "基金上市交易公告书主要的披露事项包括：基金概况(B选项属于披露事项)、基金募集情况与上市交易安排、持有人户数、持有人结构及前10名持有人(C选项属于披露事项)、主要当事人介绍、基金合同摘要、基金财务状况、基金投资组合报告(A选项属于披露事项)、重大事件揭露等。D选项不属于披露事项。"
        },
        {
            "title": "基金管理人设监事会，监事会的负责对象为（　　）。",
            "question": "A. 股东会\nB. 管理层\nC. 董事长\nD. 董事会",
            "answer": "A",
            "explain": "本题考查监事会可依法行使的职权。基金管理人设监事会，监事会向股东会(A选项符合题意)负责。"
        },
        {
            "title": "中国证券投资基金业协会的最高权力机构是（　　）。",
            "question": "A. 会长办公室\nB. 会员大会\nC. 监事会\nD. 理事会",
            "answer": "B",
            "explain": "本题考查基金业协会。基金业协会是证券投资基金行业的自律性组织，是社会团体法人。A选项不符合题意，会长办公室负责主持会议，指导和落实安排的工作。B选项符合题意，基金业协会的权力机构为全体会员组成的会员大会。C选项不符合题意，监事会向股东会负责。法规要求监事会成员中应该包括职工监事，由全体员工民主选举和罢免。公司章程应该明确监事会的职权范围、人员组成、制定议事规则，包括监事会会议的通知程序、议事方式、表决形式和会议程序。"
        },
        {
            "title": "基金管理人办理开放式基金份额的赎回时应当收取赎回费，基金管理人应当在基金合同、招募说明书中约定并按照费用标准收取赎回费，不收取销售服务费的，对持续持有期少于7日的投资人收取不低于（　　）的赎回费，对持续持有期少于30日的投资人收取不低于（　　）的赎回费，并将上述赎回费全额计入基金财产。",
            "question": "A. 1.5%,0.5%\nB. 1%,0.5%\nC. 1.5%,0.75%\nD. 1%,0.75%",
            "answer": "C",
            "explain": "本题考查基金申购赎回的销售服务费。基金管理人可以从开放式基金财产中计提一定比例的销售服务费，用于基金的持续销售和给基金份额持有人提供服务。对于一般的货币型和混合型基金赎回费归基金财产的比例做了相关规定，其中对于不收取销售服务费的：（1）对持续持有期少于7日的投资人收取不低于1.5%的赎回费(C选项符合题意)；"
        }, {
            "title": "基金销售结算资金是基金投资人的交易结算资金，涉及基金销售结算专用账户开立、使用、监智的机构不得有下列行为（　　）。",
            "questions": "I. 将基金销售结算资金归入其自有财产<br>II. 允许单位或个人以任何形式挪用基金销告结算资金<br>III. 相关机构破产或清算时，基金销售结算资金归入其破产或清算财产<br>IV. 划转现金作为该基金的分红资金",
            "question": "A. I、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查基金销告结算资金的相关规定。基金销售结算资金是指在基金投资人结算账户与基金托管账户之间划转的基金申购、赎回、现金分红等资金。基金销告结算资金的相关规定：（1）涉及基金销售结算专用账户开立、使用、监督的机构不得将基金销告结算资金归入其自有财产(I项符合题意)。"
        },
        {
            "title": "基金管理人在公募基金募集过程中需要完成的程序包含（　　）。",
            "questions": "I. 向中国证监会提交基金募集注册申请<br>II. 收到中国证监会对基金募集注册的核准文件后，组织基金发行，发布基金发售公告等法律文件<br>III. 在基金募集完成后，向中国证监会提交备案申请和验资报告<br>IV. 在收到中国证监会对新基金的备案确认文件3日内，发布基金合同生效公告",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查基金的募集程序。基金管理人应在基金合同生效的次日（并非3日内），在指定报刊和管理人网站上登载基金合同生效公告。IV项错误。I. II表述正确。"
        },
        {
            "title": "货币基金通常不需要定期披露份额净值，而是披露（　　）。",
            "question": "A. 每份基金收益、7日年化收益率\nB. 每份基金收益、3日年化收益率\nC. 每万份基金收益、3日年化收益率\nD. 每万份基金收益、7日年化收益率",
            "answer": "D",
            "explain": "本题考查基金运作信息披露中的基金净值公告。货币市场基金信息披露的特点是：货币市场基金每日分配收益，份额净值保持1元不变。因此，货币市场基金不像其他类型基金那样定期披露份额净值，而是需要披露收益公告，包括每万份基金收益和最近7日年化收益率(D选项符合题意)。"
        },
        {
            "title": "关于封闭式基金上市交易的必要条件，以下描述错误的是（　　）。",
            "question": "A. 基金合同期限为5年以上\nB. 基金份额持有人不少于1000人\nC. 基金募集金额不低于2亿元人民币\nD. 基金募集份额总额达到准予注册规模的80%",
            "answer": "D",
            "explain": "本题考查封闭式基金份额上市交易的条件。封闭式基金份额上市交易，应当符合的条件：（1）基金的募集符合《证券投资基金法》规定；(2）基金合同期限为5年以上(A项不符合题意)；（3）基金募集金额不低于2亿元人民币(C项不符合题意)；(4）基金份额持有人不少于1000人(B项不符合题意);"
        },
        {
            "title": "关于开放式基金份额登记，以下表述错误的是（　　）。",
            "question": "A. 基金份额登记具有确定和变更基金份额持有人及其权利的法律效力\nB. 基金份额登记是保障基金份额持有人合法权益的重要环节\nC. 基金销售机构负责通过设立和维护基金份额持有人名册的方式进行基金份额登记\nD. 基金份额登记是确认基金份额持有人持有基金份额的事实的行为",
            "answer": "C",
            "explain": "本题考查开放式基金份额登记概述。基金份额登记具有确定和变更基金份额持有人及其权利的法律效力(A选项表述正确)，是保障基金份额持有人合法权益的重要环节(B选项表述正确)。《证券投资基金法》规定，开放式基金的注册登记业务可以由基金管理人办理，也可以委托中国证监会认定的其他机构办理。C选项表述错误，D选项表述正确，开放式基金份额的登记是指基金注册登记机构通过设立和维护基金份额持有人名册，确认基金份额持有人持有基金份额的事实的行为。这里指的是基金注册登记机构而不是基金销售机构。"
        },
        {
            "title": "投资者T日赎回1万份某开放式基金，当日基金份额净值为1.5000元，对应的赎回费率为0.5%，其可以得到的净赎回金额为（　　）元。",
            "question": "A. 14950\nB. 14925.37\nC. 14975\nD. 14925",
            "answer": "D",
            "explain": "本题考查赎回金额的计算。赎回总额=赎回数量×赎回日基金份额净值=10000×1.5000=15000元；赎回费用=赎回总额×赎回费率=15000×0.5%=75元；赎回金额=赎回总额-赎回费用=15000-75=14925元。"
        }, {
            "title": "可以依法申请基金销售业务资格的机构包括（　　）。",
            "questions": "I. 商业银行<br>II. 期货公司<br>III. 保险公司<br>IV. 保险代理公司",
            "question": "A. I\nB. I、II、III\nC. I、II、III、IV\nD. I、II",
            "answer": "C",
            "explain": "本题考查基金销售机构的准入条件。商业银行(I项)、证券公司、期货公司(II项)、保险机构(III项、IV项)、证券投资咨询机构、独立基金销售机构以及中国证监会认定的其他机构申请注册基金销售业务资格,应满足相应要求,从事基金销售业务的,应向工商注册登记所在地的中国证监会派出机构进行注册并取得相应资质。"
        },
        {
            "title": "下列行为中属于基金注册登记机构主要职责的有（　　）。",
            "questions": "I. 发放红利<br>II. 基金份额登记，确认基金交易<br>III. 建立并管理投资者基金份额账户<br>IV. 对基金进行估值核算",
            "question": "A. II、III、IV\nB. I、II\nC. I、II、III\nD. I、III、IV",
            "answer": "C",
            "explain": "本题考查开放式基金份额登记机构及职责。I. II. III项属于我国基金注册登记机构的主要职责包括：（1）建立并管理投资者基金份额账户；（2）负责基金份额登记，确认基金交易；（3）发放红利；（4）建立并保管基金持有人名册；"
        },
        {
            "title": "为了确保内部控制机制能够有效运行，在设计内部控制机制时应采取（　　）手段。",
            "question": "A. 权力分配、相互制衡\nB. 权利集中、全面监督\nC. 权力分配、相互隔离\nD. 权利集中、全面控制",
            "answer": "A",
            "explain": "本题考查基金管理人内部控制机制的概况。内部控制机制,简称内控机制,是指公司的内部组织结构及其相互之间的运作制约关系,即一个企业组织为了实现计划目标,防范和减少风险的发生，由全体员工共同参与，对内部组织机构业务流程进行全过程的介入和监控，采取权力分配、相互制衡手段，(A选项正确)制定出系统的、制度保证的运行过程。"
        },
        {
            "title": "关于基金公司投资决策委员会的描述，以下不属于投资决策委员会所议事项的是（　　）。",
            "question": "A. 决定基金的投资原则、投资目标和投资理念\nB. 决定基金的资产分配比例，制定并定期调整投资总体方案\nC. 制定、修订公司的估值政策及程序\nD. 审批基金经理的年度投资计划并考核其执行情况",
            "answer": "C",
            "explain": "本题考查投资决策委员会。投资决策委员会所议事项具体为：（1）决定公司的投资决策程序及权限设置原则；（2）决定基金的投资原则、投资目标和投资理念(A选项正确)；（3）决定基金的资产分配比例，制定并定期调整投资总体方案(B选项正确)；（4）审批基金经理提出的行业配置及超过基金净值某比例重仓个股的投资方案；（5）审批基金经理的年度投资计划并考核其执行情况(D选项正确)。"
        },
        {
            "title": "关于货币市场基金季度报告中有关偏离度的信息披露，下列披露内容错误的是（　　）。",
            "question": "A. 报告期内偏离度的最低值\nB. 报告期内偏离度绝对值在0.2%--0.5%间的次数\nC. 报告期内偏离度的最高值\nD. 报告期内偏离度绝对值的简单平均值",
            "answer": "B",
            "explain": "本题考查货币市场基金偏离度公告。在季度报告中的投资组合报告中,货币市场基金将披露报告期内偏离度绝对值在0.25%~0.5%间的次数,偏离度的最高值和最低值,偏离度绝对值的简单平均值等信息。A、C、D选项表述正确,B选项表述错误，应是0.25%--0.5%。"
        },
        {
            "title": "根据《私募投资基金监督管理暂行办法》的规定，私募基金的合格投资者投资于单只私募基金的金额不应低于（　　）。",
            "question": "A. 50万元\nB. 300万元\nC. 500万元\nD. 100万元",
            "answer": "D",
            "explain": "本题考查私募合规投资者。私募基金合格投资者要求:具备相应风险识别和承担能力,投资于单只私募基金的金额不低于100万元(D选项符合题意)日符合:（1）净资产不低于1000万元的单位；（2）金融资产不低于300万元或最近3年个人年均收入不低于50万元的个人。"
        }, {
            "title": "M基金销售机构正在向普通投资者销售分级股票型基金，下列行为合规的是（　　）。",
            "question": "A. 以分级股票型基金过去两年的历史业绩推算未来一年的投资回报\nB. 向普通投资者说明，分级股票型基金的分级A类的投资回报类似于银行存款\nC. 向全部普通投资者群发邮件，推荐分级股票型基金\nD. 向风险承受能力最强的普通投资者解释说明分级基金的基本原理、操作流程及可能当能的风险",
            "answer": "D",
            "explain": "本题考查销售适用性。A选项行为不合规，过去的业绩不代表未来，不能用历史业绩来进行未来业绩的推算。B选项行为不合规，分级基金A类份额不能完全等同于银行存款，风险等级不一样，存在投资风险，因此向投资者的此类表述不合规。C选项行为不合规，不同投资者的风险承受能力不一样，因此不能通过群发的方式向不确定的投资者进行宣传，违反投资者适当性。D选项行为合规，风险承受能力强的投资者虽然可以购买全部基金产品，但是也需要向其进行相应的风险揭示，同时可以介绍分级基金相关内容。"
        },
        {
            "title": "以下属于QDII公募基金可投资对象的是（　　）。",
            "questions": "I. 银行存款，可转让存单，银行票据等货币市场工具<br>II. 贵重金属或代表贵重金属的凭证<br>III. 政府债券、公司债券、住房按揭支持证券<br>IV. 在已与中国证监会签署双边监管合作诗解备忘录的国家或地区证券监管机构的公募基金",
            "question": "A. III、IV\nB. I、II、IV\nC. I、III、IV\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查QDII基金的投资对象。根据有关规定，除中国证监会另有规定外，QDII基金可投资于下列金融产品或工具："
        },
        {
            "title": "根据法律形式，可以将证券投资基金分为（　　）。",
            "question": "A. 债券型和股票型\nB. 契约型和公司型\nC. 增长型和收入型\nD. 主动型和被动型",
            "answer": "B",
            "explain": "本题考查契约型基金与公司型基金。A选项错误，根据投资对象分类，可以将证券投资基金分为债券型和股票型。B选项正确，证券投资基金依据法律形式的不同，可分为契约型基金与公司型基金。C选项错误，根据投资目标分类，可以将证券投资基金分为增长型、收入型和平衡型。"
        },
        {
            "title": "私募基金管理人申请成为普通会员，应具备的条件包括（　　）。",
            "questions": "I. 应成为观察会员满一年<br>II. 应成为观察会员满两年<br>III. 符合资产管理规模标准和合规经营目标<br>IV. 从业人员数量不低于10人",
            "question": "A. II、III\nB. I、III、IV\nC. II、III、IV\nD. I、III",
            "answer": "D",
            "explain": "本题考查申请成为普通会员的条件。私募基金管理人和从事私募资产管理业务的金融机构加入协会，应先申请成为观察会员，自成为观察会员之日起满1年，同时符合资产管理规模标准及合规经营标准的，可申请成为普通会员。"
        },
        {
            "title": "关于公募基金财产的投资活动，合规的是（　　）。",
            "question": "A. 承销证券\nB. 买卖股票或债券\nC. 向基金管理人、基金托管人出资\nD. 从事承担无限责任的投资",
            "answer": "B",
            "explain": "本题考查基金投资与交易行为的限制。对基金投资与交易行为的限制包括：（1）承销证券(A选项不合规)；（2）违反规定向他人贷款或者提供担保；（3）从事承担无限责任的投资(D选项不合规)；（4）买卖其他基金份额，但是证监会另有规定的除外；"
        },
        {
            "title": "2016年2月18日，某投资者通过场外（银行)申购基金30000，假设基金管理人规定的申购费率为1.5%，申购当日基金份额净值为1元。则申购手续费和可以得到的申购份额为（　　）。",
            "question": "A. 450和29559份\nB. 450和28142.86份\nC. 443.35和29556.65份\nD. 443.35和28149.19份",
            "answer": "C",
            "explain": "本题考查基金申购金额的计算。净申购金额=申购金额/（1+申购费率）=30000/(1+1.5%)=29556.65申购费用=申购金额-净申购金额=3000-29556.65=443.35申购份额=净申购金额/申购当日基金份额净值=29556.65/1=29556.65"
        }, {
            "title": "关于基金合同对基金份额持有人权利的约定，以下表述错误的是（　　）。",
            "question": "A. 基金份额持有人可参与基金投资运作\nB. 基金份额持有人可参与分配结算后的剩余基金财产\nC. 基金份额持有人可对基金管理人、托管人或基金份额发售机构损害其合法权益的行为提起行政诉讼\nD. 基金份额持有人可要求召开基金份额持有人大会并对大会审议事项行使表决权",
            "answer": "A",
            "explain": "本题考查基金合同。基金合同是约定基金管理人、基金托管人和基金份额持有人权利义务关系的重要法律文件。A选项表述错误，基金份额持有人不得参与基金投资运作，基金管理人和托管人有权参与基金投资运作。B选项表述正确，基金份额持有人可申请赎回持有的基金份额，参与分配清算后的剩余基金财产。C选项表述正确，基金份额持有人可对基金管理人、托管人或基金份额发售机构损害其合法权益的行为依法提起行政诉讼。"
        },
        {
            "title": "目前，依据《证券投资基金法》设立的（　　）是证券投资基金行业的自律性组织。",
            "question": "A. 中国证券业协会\nB. 中国证券业协会基金公会\nC. 基金管理人联盟\nD. 中国证券投资基金业协会",
            "answer": "D",
            "explain": "本题考查基金业协会。中国证券投资基金业协会(D选项符合题意)是依据《证券投资基金法》设立的行业自律性组织，是社会团体法人。(易混:A选项中国证券业协会负责证券类，而中国证券投资基金业协会负责基金类，在2015年未调整之前基金度属于中国证券业协会)"
        },
        {
            "title": "以下需要基金托管人提供托管人报告的包括（　　）。",
            "questions": "I. 基金季度报告<br>II. 基金临时报告<br>III. 基金中期报告<br>IV. 基金年度报告",
            "question": "A. I、II、III、IV\nB. III、IV\nC. IV\nD. I、III、IV",
            "answer": "B",
            "explain": "本题考查基金报告。基金托管人应在基金半年度报告（中期报告）及年度报告中出具托管人报告，对报告期内托管人是否尽职尽责履行义务以及管理人是否遵规守约等"
        },
        {
            "title": "慧基金销售机构仅在基金投资人首次开户时对其风险承受能力评价一次，并长期使用该评价结果，该销售机构违反了基金销售适用性的（　　）。",
            "question": "A. 投资人利益优先原则\nB. 及时性原则\nC. 差异性原则\nD. 全面性原则",
            "answer": "B",
            "explain": "本题考查基金销售适用性原则。基金销售适用性是指基金销售机构在销售基金产品时，应根据投资人的风险承受能力销售不同风险等级的产品，把合适的产品卖给合适的基金投资人。基金销售适用性的原则包括：(1)投资者利益优先原则；(2)全面性原则；(3)客观性原则；(4)及时性原则；"
        },
        {
            "title": "单个开放日基金净赎回申请超过基金总份额的10%时，基金管理人的处理方式有（　　）。",
            "question": "A. 全部延期赎回\nB. 拒绝全额赎回\nC. 拒绝部分延期赎回\nD. 接受全额赎回",
            "answer": "D",
            "explain": "本题考查巨额赎回。单个开放日基金净赎回申请超过基金总份额的10%时，为巨额赎回。出现巨额赎回时，基金管理人可以根据基金当时的资产组合状况接受全额赎回或者部分延期赎回。因此，基金管理人可以采取的方式为全额赎回，或者部分延期赎回。D选项符合题意。"
        },
        {
            "title": "关于ETF份额折算，下列说法错误的是（　　）。",
            "question": "A. 基金份额折算后，基金份额持有人将按照折算前的基金份额享有权利并承担义务\nB. 折算由基金管理人办理，并由登记结算机构进行基金份额的变更登记\nC. 基金管理人通常以标的指数的1%（或1%）作为份额净值进行份额折算\nD. 基金管理人可以在基金建仓期结束后进行份额折算",
            "answer": "A",
            "explain": "本题考查ETF份额折算与变更登记。A选项错误，基金份额折算后，基金份额持有人将按照折算后的基金份额享有权利并承担义务。B选项正确，ETF份额折算由基金管理人办理，并由登记结算机构进行基金份额的变更登记。C、D选项正确，基金建仓期结束后，为方便投资者跟踪基金份额净值变化，基金管理人通常会以某一选定日期作为基金份额折算日，以标的指数的1%（或1%）作为份额净值对原来的基金份额及其净值进行折算。"
        }, {
            "title": "基金公司合规管理的主要内容包括（　　）。",
            "questions": "I. 合规文化<br>II. 合规政策<br>III. 合规审核<br>IV. 合规检查",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、III、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查合规管理的内容。合规管理是一种风险管理活动，是对业务活动是否遵守法律、监管规定、规则、行业自律准则等的一种鉴证行为，基金公司合规管理的主要内容包括：合规文化、合规政策、合规审核、合规检查、合规培训和合规投诉处理。"
        },
        {
            "title": "关于基金信息披露的作用，以下表述错误的是（　　）。",
            "question": "A. 有利于基金份额持有人对基金投资运作及时提出建议\nB. 有利于基金份额持有人评价其所持基金的基金经理的管理水平\nC. 有利于基金份额持有人判断是否值得继续持有\nD. 有利于投资者判断是否适合投资",
            "answer": "A",
            "explain": "本题考查基金信息披露的作用。基金信息披露的作用主要表现在四个方面：(1)有利于投资者的价值判断；(2)有利于防止利益冲突与利益输送；(3)有利于提高证券市场的效率；(4)能有效防止信息滥用。"
        },
        {
            "title": "普通非货币市场基金的净值公告不包括（　　）。",
            "question": "A. 资产累计净值\nB. 份额累计净值\nC. 份额净值\nD. 资产净值",
            "answer": "A",
            "explain": "本题考查普通非货币市场基金的基金净值公告。普通非货币基金的净值公告内容包括基金资产净值、份额净值、份额累计净值等信息，不包括资产累计净值。"
        },
        {
            "title": "基金从业人员职业道德中的诚实守信，要求不得利用内幕信息进行内幕交易，以下尚未公开的信息中不属于内幕信息的是（　　）。",
            "question": "A. 某上市公司董事长涉嫌犯罪被刑事拘留\nB. 某上市公司人员招聘计划\nC. 某上市公司董事长收到律所合伙人发来的重大资产重组协议终稿，写有本次重组的方案和价格\nD. 某上市公司持股8%的股东拟对外出售其全部股权的计划",
            "answer": "B",
            "explain": "本题考查内幕信息的定义。内幕交易，是指利用内幕信息进行证券交易，以为自己或者他人牟取利益。所谓内幕信息，是指能够影响证券价格的重要非公开信息。内幕信息的构成要素有三方面：一是来源可靠的信息，来源不可靠、模棱两可的信息，即便对证券价格产生影响，也不构成内幕信息。二是“重要”的信息，即该信息对于证券价格的影响明确。如果该信息的披露会对证券价格产生影响或者属于理性投资者在做投资决策前希望知悉的，那么，该信息就是“重要”的。例如，足以影响证券价格的公司重组、并购决策或者财务报告等信息。"
        }, {
            "title": "监事会在下列哪种情况下，拥有代表基金管理公司的权利（　　）。",
            "questions": "I. 当公司与董事间发生诉讼时，除法律另有规定外，由监事会代表公司作为诉讼一方处理有关法律事宜<br>II. 当董事自己或他人与本公司有交涉时，由监事会代表公司与董事进行交涉<br>III. 当监事调查公司业务及财务状况、审核账册报表时，有权代表公司委托律师、会计师或其他第三方人员协助调查<br>IV. 当公司与总经理之间发生诉讼时，由监事会代表作为诉讼一方处理有关法律事宜",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、III、IV",
            "answer": "C",
            "explain": "本题考查监事会代表公司的特殊情况。存在特殊情况下，监事会有代表公司的权利："
        },
        {
            "title": "关于ETF的申购赎回的信息披露，错误的是（　　）。",
            "question": "A. 在每日开市前，基金管理人需通过其官方网站和证券交易所指定的信息发布渠道公告ETF申购、赎回额\nB. ETF申购、赎回清单主要包括最小申购、赎回单位对应的各证券名称、证券代码及数量、现金替代标志\nC. 在每日开市前，基金管理人需向证券交易所，证券登记结算机构提供ETF申购、赎回清单\nD. 当日发布的ETF申购、赎回清单，当日可根据市场特殊情况进行修改",
            "answer": "D",
            "explain": "本题考查ETF的信息披露。ETF是以某一选定的指数所包含的成分证券或商品为投资对象，采取完全复制或抽样复制，进行被动投资的指数基金。A、C选项正确，在每日开市前，基金管理人需向证券交易所、证券登记结算机构提供ETF的申购清单和赎回清单，并通过基金公司官方网站和证券交易所指定的信息发布渠道予以公告。"
        },
        {
            "title": "关于基金管理公司各业务部门在风险管理中的职责，以下表述错误的是（　　）。",
            "question": "A. 对本部门或业务单元的主要风险进行及时的识别、评估、检讨、回顾\nB. 研究制定本部门或业务单元决策和运作的各项制度流程并组织实施\nC. 及时、准确、全面、客观地将本部门的风险信息和监测情况向董事会报告\nD. 具体制定本部门业务相关的风险管理制度和相关应对措施、控制流程、监控指标等",
            "answer": "C",
            "explain": "本题考查各业务部门风险管理职责。各业务部门应当承担如下职责：（1）遵循公司风险管理政策，研究制定本部门或业务单元业务决策和运作的各项制度流程并组织实施，具体制定本部门业务相关的风险管理制度和相关应对措施、控制流程、监控指标等，或与风险管理职能部门协作制定相关条款，将风险管理的原则与要求贯穿业务开展的全过程；（2）随着业务的发展，对本部门或业务单元的主要风险进行及时的识别、评估、检讨、回顾，提出应对措施或改进方案，并具体实施；（3）严格遵守风险管理制度和流程，及时、准确、全面、客观地将本部门的风险信息和监测情况向管理层和风险管理职能部门或岗位报告(并非董事会报告);"
        },
        {
            "title": "根据基金宣传推介材料规范性要求，以下属于不当宣传用语的是（　　）。",
            "questions": "I. 坐享财富增长<br>II. 安心享受成长<br>III. 尽享牛市<br>IV. 认购日期截止到X年X月X日",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、III、IV\nD. II、III、IV",
            "answer": "A",
            "explain": "本题考查基金宣传推介材料的禁止性规定。基金宣传推介材料禁止使用：（1）虚假记载、误导性陈述或者重大遗漏；"
        },
        {
            "title": "某基金销售人员为投资者办理基金开户手续时，须完成以下哪些事项（　　）。",
            "questions": "I. 有效识别投资者身份<br>II. 向投资者提供\"投资者权益须知\"<br>III. 向投资者介绍基金投资业绩<br>IV. 了解投资者投资目标和风险偏好等",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、III\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查基金开户手续的办理。基金销售人员在为投资者办理基金开户手续时，应严格遵守《证券投资基金销售机构内部控制指导意见》的有关规定，并注意如下事项：（1）有效识别投资者身份(I项须完成);"
        },
        {
            "title": "基金产品风险评价的依据因素不包括（　　）。",
            "question": "A. 基金历史规模、持仓比例\nB. 基金过往业绩及基金净值的历史波动程度\nC. 基金成立以来有无违法行为发生\nD. 招募说明书列示的基金管理费率、收益分配政策",
            "answer": "D",
            "explain": "基金产品的风险评价依据：（1）基金招募说明书所明示的投资方向、投资范围和投资比例；（2）基金的历史规模和持仓比例(包括A选项)；（3）基金的过往业绩及基金净值的历史波动程度(包括B选项);"
        }, {
            "title": "忠诚尽责，是调整基金从业人员与（　　）之间关系的职业道德规范。",
            "question": "A. 基金管理人\nB. 其所在机构\nC. 客户\nD. 基金托管人",
            "answer": "B",
            "explain": "本题考查忠诚尽责。忠诚尽责是调整基金从业人员与其所在机构之间关系的职业道德规范。B选项符合题意。"
        },
        {
            "title": "基金销售机构在监测客户款项划转时，发现有可疑行为，应在其发生后10个工作日内，向（　　）报告。",
            "question": "A. 中国证监会\nB. 中国反洗钱监测分析中心\nC. 中国人民银行\nD. 中国证券投资基金业协会",
            "answer": "B",
            "explain": "本题考查基金销售机构反洗钱。基金销售机构在监测客户款项划转时，对符合大额交易标准的，在该大额交易发生后5个工作日内，向中国反洗钱监测分析中心报告(B选项符合题意)。在发现有可疑交易或者行为时，在其发生后10个工作日内，向中国反洗钱监测分析中心报告。"
        },
        {
            "title": "关于基金托管人职责终止的原因，以下表述错误的是（　　）。",
            "question": "A. 依法解散、被依法撤销或者被依法宣告破产的，基金托管人职责终止\nB. 被基金份额持有人大会解任的，基金托管人职责终止\nC. 在履行法定职责时存在失误，基金托管人职责终止\nD. 被依法取消基金托管资格的，基金托管人职责终止",
            "answer": "C",
            "explain": "本题考查基金托管人职责终止的原因。基金托管人职责终止的原因包括：（1）被依法取消基金托管资格(D选项表述正确)；（2）被持有人大会解任(B选项表述正确)；（3）依法解散、被依法撤销或者被依法宣告破产(A选项表述正确)。"
        },
        {
            "title": "以下不需要披露上市交易公告书的是（　　）。",
            "question": "A. 交易型开放式指数基金(ETF)联接基金\nB. 封闭式基金\nC. 交易型开放式指数基金(ETF)\nD. 上市开放式基金(LOF)",
            "answer": "A",
            "explain": "本题考查披露上市交易公告书的基金品种。凡是根据有关法律法规发售基金份额并申请在证券交易所上市交易的基金，基金管理人均应编制并披露基金上市交易公告书。目前，披露上市交易公告书的基金品种主要有封闭式基金、上市开放式基金(LOF)和交易型开放式指数基金(ETF)以及分级基金子份额。"
        },
        {
            "title": "中国证监会派出机构负责如下哪些机构进行日常监督（　　）。",
            "questions": "I. 辖区内的基金管理公司<br>II. 辖区内的基金代销机构<br>III. 辖区内的异地基金管理公司的子公司",
            "question": "A. I、II、III\nB. II、III\nC. I、III\nD. I、II",
            "answer": "A",
            "explain": "本题考查中国证监会的职责。各证监局负责对经营所在地在本辖区内的基金管理公司(I项正确)进行日常监管，主要包括公司治理和内部控制、高级管理人员、基金销售行为、开放式基金信息披露的日常监管；负责对辖区内异地基金管理公司的分支机构(II项正确)及基金代销机构(III项正确)进行日常监管。"
        },
        {
            "title": "认购费和申购费可以采用在基金份额发售或者申购时收取的（　　）收费方式，也可以采用在赎回时从赎回金额中扣除的（　　）收费方式。",
            "question": "A. 后端，前端\nB. 前置，后置\nC. 后置，前置\nD. 前端，后端",
            "answer": "D",
            "explain": "本题考查基金申购费用的内容。投资者在办理开放式基金申购时，一般需要缴纳申购费，和认购费一样，申购费可以采用在基金份额申购时收取的前端收费方式，也可以采用在赎回时从赎回金额中扣除的后端收费方式。"
        }, {
            "title": "“四位一体”的基金监管格局是指（　　）。",
            "question": "A. 以机构内控为核心、行业自律为基础、行政监管为纽带、社会监督为补充\nB. 以机构内控为核心、行政监管为基础、社会监督为纽带、行业自律为补充\nC. 以行政监管为核心、机构内控为基础、行业自律为纽带、社会监督为补充\nD. 以行业自律为核心、行政监管为基础、社会监督为纽带、机构内控为补充",
            "answer": "C",
            "explain": "本题考查基金监管的基本原则。对于基金而言，行政监管不应直接干预基金机构内部的经营管理，监管范围应严格限定在基金市场失灵的领域。应完善基金行业自律机制、健全基金机构内控机制和培育社会力量监督机制，充分发挥基金行业自律、基金机构内控和社会力量监督机制在基金监管方面的积极作用，形成以行政监管为核心、行业自律为纽带、机构内控为基础、社会监督为补充的“四位一体”的监管格局。"
        },
        {
            "title": "QDII基金开放申购、赎回后，净值信息的披露要求是（　　）。",
            "question": "A. 每个自然日披露份额净值和份额累计净值\nB. 每个自然日披露份额净值，无需披露份额累计净值\nC. 每个开放日披露份额净值，无需披露份额累计净值\nD. 每个开放日披露份额净值和份额累计净值",
            "answer": "D",
            "explain": "本题考查QDII基金的信息披露。QDII基金在封闭期一般至少每周披露一次资产净值和份额净值，开放期披露每个开放日的份额净值和份额累计净值。D选项符合题意。"
        },
        {
            "title": "关于风险评估，以下描述正确的是（　　）。",
            "questions": "I. 风险评估可以采取定性和定量相结合的方式。<br>II. 风险评估就是识别和分析与实现目标相关的风险，从而为管理风险奠定基础。<br>III. 风险评估就是其他风险管理要素的基础。",
            "question": "A. I、II\nB. II、III\nC. I、II、III\nD. I、III",
            "answer": "A",
            "explain": "本题考查风险管理程序。I项描述正确，风险评估的过程根据不同的情况，可采用定性和定量相结合的方法。II项描述正确，风险评估就是识别和分析与实现目标相关的风险，从而为确定应该如何管理风险奠定基础。III项描述错误，基金管理人的内部环境(而不是风险评估)是其他所有风险管理要素的基础，为其构成要素提供规则和结构，其中特别重要的是管理层。"
        },
        {
            "title": "关于基金管理人合规管理的独立性原则，以下表述错误的是（　　）。",
            "question": "A. 合规部门在基金公司组织体系中应当有独立性\nB. 职工监事在基金公司组织体系中应当有独立性\nC. 合规管理应当独立于其他各项业务经营活动\nD. 督察长在基金公司组织体系中应当有独立性",
            "answer": "B",
            "explain": "本题考查独立性原则。独立性原则主要是指合规部门和督察长在基金公司组织体系中应当有独立地位，合规管理应当独立于其他各项业务经营活动。这是合规管理的关键性原则。"
        },
        {
            "title": "根据中国证券投资基金业协会的自律规则规定，关于股权投资基金管理人募集资金，以下表述错误的是（　　）。",
            "question": "A. 委托有资质的销售机构宣传推介其管理的基金\nB. 自行宣传推介股权投资基金\nC. 委托销售机构募集基金的，可以豁免管理人的募集应承担的责任\nD. 委托销售机构推介基金应当建立避选机制",
            "answer": "C",
            "explain": "本题考查私募基金销售的主体及原则性要求。A选项表述正确，在中国证监会注册取得基金销售业务资格并已成为中国基金业协会会员的机构可以受私募基金管理人的委托募集私募基金；B选项表述正确，在中国基金业协会办理私募基金管理人登记的机构可以自行募集其设立的私募基金；C选项表述错误，权利义务是以书面形式约定的，即使委托销售机构募集基金，也不能豁免管理人募集应承担的责任。私募基金管理人委托基金销售机构募集私募基金的，应当以书面形式签订基金销售协议，并将协议中关于私募基金管理人与基金销售机构权利义务划分以及其他涉及投资者利益的部分作为基金合同的附件。"
        },
        {
            "title": "我国封闭式基金在达成交易后，二级市场交易份额和股份的交割是在（　　）日，资金交割是在（　　）日完成。",
            "question": "A. T+0, T+1\nB. T+1, T+0\nC. T+0, T+0\nD. T+1, T+1",
            "answer": "A",
            "explain": "本题考查封闭式基金交易规则。我国封闭式基金在达成交易后，二级市场交易份额和股份的交割是在T+0日，资金交割是在T+1日完成。"
        }, {
            "title": "关于基金销售机构的准入条件，以下说法正确的有（　　）。",
            "questions": "I. 制定了完善的基金清算流程，资金管理符合中国证券登记结算有限责任公司对基金销售资金管理的有关要求<br>II. 有评价基金投资人风险承受能力和基金产品风险等级的方法体系<br>III. 财务状况良好，运作规范稳定<br>IV. 基金销售业务的技术系统已与基金托管人相应的技术系统进行了联网测试，测试结果符合国家规定的标准",
            "question": "A. I、II、III、IV\nB. II、III、IV\nC. II、III\nD. I、II、III",
            "answer": "C",
            "explain": "本题考查基金销售机构的准入条件。I项说法错误，基金销售机构的准入条件包括制定了完善的资金清算流程，资金管理符合中国证监会（而不是中国证券登记结算有限责任公司）对基金销售资金管理的有关要求。"
        },
        {
            "title": "关于公募基金年度报告，下列表述正确的是（　　）。",
            "question": "A. 基金年度报告应披露近5年每年的基金收益分配情况\nB. 基金年度报告须经3/4以上独立董事签字同意，并由董事长签发\nC. 基金年度报告应当在每年结束之日起60日内编制完成并公告\nD. 基金年度报告的财务会计报告应当经过审计",
            "answer": "D",
            "explain": "本题考查基金年度报告。A选项表述错误，基金年度报告应披露近3年每年的基金收益分配情况。B选项表述错误，基金年度报告应经2/3以上独立董事签字同意，并由董事长签发。C选项表述错误，每年结束之日起90日内，编制完成基金年度报告，并将年度报告正文登载在网站上，将年度报告摘要登载在指定报刊上。D选项表述正确，基金年度报告的财务会计报告应当经过审计。"
        },
        {
            "title": "当影子定价所确定的基金资产净值超过摊余成本法计算的基金资产净值，且偏离达到一定程度时，货币市场基金应当（　　）。",
            "question": "A. 在定期报告中披露偏离度信息\nB. 标明基金组合存在浮亏\nC. 标明两种估值方法得到的结果不同，基金组合不存在浮盈和浮亏\nD. 标明基金组合存在浮盈",
            "answer": "D",
            "explain": "本题考查货币市场基金偏离度公告。A选项错误，在半年度报告和年度报告的重大事件提示中，基金管理人将披露报告期内偏离度的绝对值达到或超过0.5%的信息（并不是任何情况都会在定期报告中披露）。B、C选项错误，D选项正确，当影子定价所确定的基金资产净值超过摊余成本法计算的基金资产净值（即产生正偏离）时，表明基金组合中存在浮盈；反之，当存在负偏离时，则基金组合中存在浮亏。此时，若基金投资组合的平均剩余期限和融资比例仍较高，则该基金隐含的风险较大。"
        },
        {
            "title": "关于基金宣传推介材料审批报备流程，以下表述正确的是（　　）。",
            "question": "A. 基金宣传推介材料需报主要经营活动所在地中国证监会派出机构备案\nB. 基金宣传推介材料需经主要经营活动所在地中国证监会派出机构审核\nC. 基金宣传推介材料需报中国证监会备案\nD. 基金宣传推介材料需经中国证监会审核",
            "answer": "A",
            "explain": "本题考查基金宣传推介材料审批报备流程。基金宣传推介材料书面报告报送基金管理公司或基金代销机构主要办公场所所在地证监局备案，报送监局时应随附电子文档。A选项符合题意。"
        },
        {
            "title": "开放式基金合同生效后，可以在规定的期限内不办理赎回，但该期限最长不超过（　　）。",
            "question": "A. 一个月\nB. 六个月\nC. 一年\nD. 三个月",
            "answer": "D",
            "explain": "本题考查开放式基金封闭期的申购赎回。开放式基金是指基金份额不固定,基金份额可以在基金合同约定的时间和场所进行申购或者赎回的一种基金运作方式。开放式基金合同生效后，可以在基金合同和招募说明书规定的期限(封闭期)内不办理赎回，但该期限最长不超过3个月(D选项符合题意)。"
        },
        {
            "title": "关于中国证券投资基金业协会的职责，以下表述错误的是（　　）。",
            "question": "A. 组织基金从业人员的业务培训\nB. 对基金在交易所的交易活动进行监管\nC. 监督、检查基金从业人员的执业行为\nD. 依法办理非公开募集基金的登记、备案",
            "answer": "B",
            "explain": "本题考查基金业协会的职责。A选项表述正确，基金业协会负责制定行业执业标准和业务规范，组织基金从业人员的从业考试、资质管理和业务培训。B选项表述错误,中国证监会对基金在交易所的交易活动进行监管，而不是基金业协会。C选项表述正确，基金业协会负责制定和实施行业自律规则，监督、检查会员及其从业人员的执业行为，对违反自律规则和协会章程的，按照规定给予纪律处分。D选项表述正确，基金业协会依法办理非公开募集基金的登记、备案。"
        }, {
            "title": "关于货币市场基金收益公告，以下表述错误的是（　　）。",
            "question": "A. 货币市场基金开放日的收益公告是指货币市场基金每个开放日次日披露每万份基金净收益和最近7日年化收益率\nB. 货币市场基金节假日的收益公告是指遇到法定节假日时，于节假日结束后第一个自然日披露节假日期间的每万份基金净收益\nC. 货币市场基金封闭期的收益公告，包括基金合同生效后，基金管理人开始办理基金份额申购或者赎回前一日的基金资产净值\nD. 货币市场基金需要披露收益公告，包括每万份基金净收益和最近7日年化收益率",
            "answer": "B",
            "explain": "本题考查货币市场基金收益公告和偏离度公告。A选项、D选项表述正确，开放日的收益公告是指货币市场基金于每个开放日的次日在中国证监会指定报刊和管理人网站上披露开放日每万份基金净收益和最近7日年化收益率。B选项表述错误，节假日的收益公告是指货币市场基金开放申购和赎回后，在遇到法定节假日时，于节假日结束后第2个自然日披露节假日期间的每万份基金净收益，节假日最后1日的7日年化收益率，以及节假日后首个开放日的每份基金净收益和7日年化收益率。C选项表述正确，封闭期的收益公告是指货币市场基金的基金合同生效后，基金管理人于开始办理基金份额申购或者赎回当日，在中国证监会指定的报刊和基金管理人网站上披露截至前一日的基金资产净值，基金合同生效至前一日期间的每万份基金净收益，前一日的7日年化收益率。"
        },
        {
            "title": "私募基金管理人应当按照合同约定，如实向投资者披露基金相关信息，不需要披露的事项是（　　）。",
            "question": "A. 基金的销售机构及基金承担的费用\nB. 基金投资收益分配\nC. 基金的资产负债表\nD. 基金公司计提的风险准备金",
            "answer": "D",
            "explain": "本题考查非公开募集基金的信息披露。《私募投资基金监督管理暂行办法》规定，私募基金管理人、私募基金托管人应当按照合同约定，如实向投资者披露：（1）基金投资；（2）资产负债(C选项不符合题意)；（3）投资收益分配(B选项不符合题意)；（4）基金承担的费用(A选项不符合题意)和业绩报酬；（5）可能存在的利益冲突情况以及可能影响投资者合法权益的其他重大信息，不得隐瞒或者提供虚假信息。"
        },
        {
            "title": "中国证监会对（　　）实行注册管理。",
            "question": "A. 基金评价机构\nB. 基金份额登记机构\nC. 基金投资顾问机构\nD. 基金信息技术服务机构",
            "answer": "B",
            "explain": "本题考查基金服务机构注册或备案的内容。中国证监会对于公开募集基金的基金份额登记机构(B选项符合题意)、基金估值核算机构实行注册管理，对于基金投资顾问机构、基金评价机构、基金信息技术服务机构实行备案管理。"
        },
        {
            "title": "关于商业银行销售基金，以下说法错误的是（　　）。",
            "question": "A. 取得销售资格的商业银行可以销售市场上的任何基金产品,无需再与基金管理人确认\nB. 商业银行销售基金必须取得基金销售资格\nC. 基金管理人应对拟销售其产品的商业银行进行资格审查\nD. 基金管理人在取得销售资格的商业银行销售其管理的基金产品，需经该银行同意",
            "answer": "A",
            "explain": "本题考查基金销售。A选项说法错误，取得销售资格的商业银行可以销售市场上的任何基金产品，但需基金管理人确认后方可销售。B选项说法正确，从事基金销售必须取得基金销售资格，因此商业银行必须在取得销售资格的情况下销售基金。C选项说法正确，基金管理人应对拟销售其产品的商业银行进行资格审查。D选项说法正确，基金管理人在取得销售资格的商业银行销售其管理的基金产品，需要经该银行同意。"
        },
        {
            "title": "基金合同的主要内容不包括（　　）。",
            "question": "A. 基金管理人、基金托管人的名称和住所\nB. 基金收益分配原则、执行方式\nC. 基金风险揭示\nD. 基金财产的投资方向和投资限制",
            "answer": "C",
            "explain": "本题考查基金合同的内容。基金合同的披露事项包括：（1）募集基金的目的和基金名称；（2）基金管理人、基金托管人的名称和住所(A项不符合题意)；（3）基金份额发售、交易、申购、赎回的程序、时间、地点、费用计算方式以及给付赎回款项的时间和方式；（4）基金收益分配原则、执行方式(B项不符合题意)；（5）基金财产的投资方向和投资限制(D项不符合题意)；"
        },
        {
            "title": "根据《证券期货投资者适当性管理办法》,营业网点向普通投资者进行有关告知和警示时,应当全过程录音或录像,这些告知或警示包括（　　）。",
            "questions": "I. 普通投资者申请成为专业投资者，警示其能承担的风险，告知申请的审查结果及其理由<br>II. 向普通投资者介绍基金产品<br>III. 根据普通投资者和产品或者服务的信息变化情况主动调整投资者分类、产品或者服务分级以及适当性配置意见，并告知投资者上述情况<br>IV. 向普通投资者销售产品或提供服务前履行特别告知义务",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、III、IV\nD. I、III、IV",
            "answer": "D",
            "explain": "本题考查录音或录像要求。通过营业网点向普通投资者进行以下告知、警示时，应当全过程录音或者录像：通过互联网等非现场方式进行的，经营机构应当完善配套保质安排。"
        }, {
            "title": "关于基金销售机构管理的说法错误的是（　　）。",
            "question": "A. 销售人员招聘程序，明确资格条件，审慎考查应聘人员\nB. 基金销售机构应建立科学合理的销售绩效评价体系，健全激励、约束机制\nC. 对于通过中国证券投资基金业协会资质考核并获得基金销售资格的基金销售人员，应自行办理执业注册\nD. 基金销售机构应加强对销售人员的日常管理，建立管理档案，对销售人员行为、诚信、奖惩等情况进行记录",
            "answer": "C",
            "explain": "本题考查基金销售机构人员的管理和培训。A选项说法正确，基金销售机构应完善销售人员招聘程序，明确资格条件，审慎考查应聘人员。B选项说法正确，基金销售机构应建立科学合理的销售绩效评价体系，健全激励、约束机制。C选项说法错误，基金销售机构对于通过基金业协会资质考核并获得基金销售资格的基金销售人员，统一办理执业注册、后续培训和职业年检，而不是自行办理。"
        },
        {
            "title": "关于债券型基金与债券的区别，以下说法错误的是（　　）。",
            "question": "A. 债券型基金一般收益不固定，债券一般收益固定\nB. 债券型基金的风险一般与期限无关，债券的风险一般随到期日临近所承担的利率风险会下降\nC. 债券型基金投资于多只债券，比债券的信用风险高\nD. 债券型基金一般没有确定的到期日，债券一般有确定的到期日",
            "answer": "C",
            "explain": "本题考查债券基金与债券的区别。C项说法错误，债券基金通过分散投资可以有效避免单一债券可能面临的较高的信用风险。"
        },
        {
            "title": "下列适用于基金产品注册普通程序的是（　　）。",
            "questions": "I. 合格境内机构投资者(QDII)基金<br>II. 交易型指数基金<br>III. 货币市场基金<br>IV. 基金中基金(FOF)",
            "question": "A. IV\nB. I、III、IV\nC. I、II、III、IV\nD. II、IV",
            "answer": "A",
            "explain": "本题考查基金募集申请的注册。中国证监会将注册程序分为简易程序和普通程序。适用于简易程序的产品包括常规股票基金、混合基金、债券基金、指数基金、货币基金、发起式基金、合格境内机构投资者(QDII)基金、理财基金和交易型指数基金(含单市场、跨市场/跨境ETF)及其联接基金。"
        },
        {
            "title": "某投资者赎回某开放式混合型基金A类基金份额1000份，持有期为20日，假设适用的赎回费率为0.75%，赎回当日A类基金份额净值是1.0600元，所有计算均采用四舍五入方式。其需支付的赎回费用和可得到的赎回金额为（　　）。",
            "question": "A. 7.05元,992.05元\nB. 7.50元、1052.50元\nC. 7.95元，1052.05元\nD. 7.50元，992.50元",
            "answer": "C",
            "explain": "本题考查开放式基金赎回金额的计算。赎回金额的计算公式如下：赎回总额=赎回数量×赎回日基金份额净值=1.0600×1000=1060元；赎回费用=赎回总额×赎回费率=1060×0.75%=7.95元；赎回金额=赎回总额-赎回费用=1060-7.95=1052.05元"
        },
        {
            "title": "私募基金的合格投资者需要提供金融资产证明材料，以下不属于金融资产的是（　　）。",
            "question": "A. 银行存款、银行理财产品\nB. 股票基金、债券基金\nC. 房地产\nD. 资产管理计划",
            "answer": "C",
            "explain": "本题考查金融资产的概念。对于私募基金的合格投资者而言，金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。综上所述，C选项不属于金融资产。"
        },
        {
            "title": "根据《证券投资基金法》、《私募投资基金管理人登记和基金备案办法(试行)》等法律法规的规定，负责办理私募基金管理人登记工作的机构是（　　）。",
            "question": "A. 中国证监会\nB. 中国证监会派出机构\nC. 中国证券投资基金业协会\nD. 地方私募基金行业协会",
            "answer": "C",
            "explain": "本题考查非公开募集基金管理人登记。根据《证券投资基金法》的规定，中国证监会委托中国证券投资基金业协会办理私募基金管理人登记。"
        }, {
            "title": "关于基金销售渠道的审慎调查，以下描述正确的是（　　）。",
            "questions": "I. 应当优先根据被调查方公开披露的信息进行甄别<br>II. 对被调查方提供的非公开信息的适当性实施尽职甄别<br>III. 可接受被调查方提供的非公开信息<br>IV. 仅可接受被调查方提供的公开信息",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、III、IV\nD. II、III、IV",
            "answer": "A",
            "explain": "本题考查基金销售渠道审慎调查。开展审慎调查应当优先根据被调查方公开披露的信息进行（I项表述正确）接受被调查方提供的非公开信息使用的，必须对信息的适当性实施尽职甄别（II. III项表述正确）。"
        },
        {
            "title": "关于基金托管人应当履行的职责，以下表述错误的是（　　）。",
            "question": "A. 监督基金管理人的投资运作\nB. 编制基金财务会计报告、中期和年度基金报告\nC. 安全保管基金财产\nD. 复核、审查基金管理人计算的基金资产净值和基金份额申购、赎回价格",
            "answer": "B",
            "explain": "本题考查托管人的职责。基金托管人的职责包括：（1）安全保管基金财产（C选项属于托管人职责）；(2）对基金财务会计报告、中期和年度基金报告出具意见（B选项不属于托管人的职责，基金托管人出具意见，而非编制）；（3）复核、审查基金管理人计算的基金资产净值和基金份额申购、赎回价格（D选项属于托管人职责）；（4）按照规定监督基金管理人的投资运作（A选项属于托管人职责）。"
        },
        {
            "title": "下列报告中，必须要基金托管人出具托管人报告，对报告期内基金托管人是否尽职尽责履行义务以及基金管理人是否遵规守约等情况做出声明的是（　　）。",
            "question": "A. 季度报告\nB. 中期报告\nC. 更新的基金招募说明书\nD. 月度财务报告",
            "answer": "B",
            "explain": "本题考查基金托管人的信息披露义务。在基金半年度报告（中期报告）及年度报告中出具托管人报告，对报告期内托管人是否尽职尽责履行义务以及管理人是否遵规守约等情况做出声明。故本题选B选项。"
        },
        {
            "title": "关于基金普通投资者的特别保护，以下说法错误的是（　　）。",
            "question": "A. 销售机构不得向普通投资者主动推介不符合其投资目标的产品\nB. 销售机构向普通投资者销售高风险产品时应当履行特别的注意义务\nC. 通过营业网点向普通投资者进行有关告知和警示时，应当布置全程录音或录像等留痕安排，但通过互联网等非现场方式进行的\nD. 销售机构不得向风险承受能力最低类别的普通投资者销售风险等级高于其风险承受能力的基金产品",
            "answer": "C",
            "explain": "本题考查普通投资者的保护。A、D选项说法正确。基金销售机构不得向普通投资者主动推介风险等级高于其风险承受能力的产品或者服务，也不得向普通投资者主动推介不符合其投资目标的产品或者服务；不得向风险承受能力最低类别的普通投资者销售风险等级高于其风险承受能力的基金产品或者服务。B选项说法正确，普通投资者在信息告知、风险警示、适当性匹配等方面享有特别保护。C选项说法错误，通过营业网点向普通投资者进行以下告知、警示时，应当全过程录音或者录像通过互联网等非现场方式进行的。经营机构应当完善配套留痕安排，由普通投资者通过符合法律、行政法规要求的电子方式进行确认。"
        },
        {
            "title": "A银行基金风险管理部拟对其销售的基金产品进行风险评价，其需要考虑的因素包括（　　）。",
            "questions": "I. 基金投资方向和范围<br>II. 基金历史规模和持仓比例<br>III. 基金过往业绩<br>IV. 基金流动性、杠杆情况",
            "question": "A. I、II\nB. I、II、III、IV\nC. I、III\nD. I、II、III",
            "answer": "B",
            "explain": "本题考查基金产品的风险评价依据。基金产品的风险评价依据：（1）基金招募说明书所明示的投资方向、投资范围和投资比例（I选项表述正确）；"
        },
        {
            "title": "关于金融与居民理财，下列说法错误的是（　　）。",
            "question": "A. 居民的消费、储蓄与投资意愿跟金融市场的表现关联度较低\nB. 在生产经营活动中，收入产生盈余的居民希望将他们的货币盈余使用出去，以获得更多的回报，因此产生理财的需求\nC. 居民理财的主要方式是货币储蓄与投资两类\nD. 所谓金融，简单来讲即货币资金的融通，而货币资金的来源为居民(包括个人和企业)从事的生产活动",
            "answer": "A",
            "explain": "本题考查金融与居民理财的关系。A选项错误，居民的消费、储蓄与投资意愿与金融市场的表现相关。居民是社会最古老、最基本的经济主体，在从自给自足经济向市场经济的逐步发展中，居民的经营活动与金融的联结越来越紧密。B选项正确，居民的货币收入大于支出产生盈余，反之，则产生赤字。产生盈余的居民希望将他们的货币盈余使用出去，以获得更多的回报，因此产生理财的需求。C选项正确，目前，居民理财主要方式是货币储蓄与投资两类。D选项正确，所谓金融，简单来讲即货币资金的融通。货币资金来源于居民(包括个人和企业)从事的生产活动。"
        }, {
            "title": "某证券投资基金合同生效已超过10年，投资业绩表现良好，关于该基金宣传推介材料的业绩登载，以下表述正确的是（　　）。",
            "questions": "I. 应当登载最近10个完整会计年度的业绩<br>II. 推介该基金的定期定额投资业务时，可以采用我国证券市场具有代表性的指数，对其过往足够长时间的实际收益率进行模拟<br>III. 可以表明10年的优异业绩表现对未来业绩表现构成强有力的支持<br>IV. 该基金的业绩表现，是该基金管理人管理其他基金的业绩保证",
            "question": "A. I、II\nB. I、II、III\nC. II、III、IV\nD. I、II、III、IV",
            "answer": "A",
            "explain": "本题考查基金宣传推介材料业绩登载规范。I说法正确，基金合同生效10年以上的，应当登载最近10个完整会计年度的业绩；II说法正确，推介定期定额投资等需要模拟历史业绩的，应当采用模拟最近证券市场具有代表性的指数，对过往足够长时间区间的实际收益率进行模拟 ；III说法错误，基金宣传推介材料不能对未来业绩表现提供保证；IV说法错误，基金管理人不能登载该基金的业绩预测 。"
        },
        {
            "title": "基金管理公司风险管理的全面性原则，体现在（　　）。",
            "questions": "I. 风险管理必须覆盖公司的各项业务<br>II. 风险管理必须覆盖公司的各个部门<br>III. 风险管理必须覆盖公司的各个岗位<br>IV. 风险管理必须渗透到决策、执行和反馈的各个业务环节",
            "question": "A. I、II、III\nB. I、II、IV\nC. II、III、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查基金管理公司风险管理的全面性原则。风险管理应覆盖公司的各项业务、各个部门和各个岗位，渗透到决策、执行、反馈等各个业务环节，所以风险管理制度要覆盖公司的各项业务，风险管理必须覆盖公司的各个岗位，风险管理必须覆盖公司的各个部位，风险管理必须渗透到决策、执行、反馈等各个业务环节，这四点均体现了全面性原则。"
        },
        {
            "title": "关于信息披露，以下说法错误的是（　　）。",
            "question": "A. 禁止过度营销，误导性陈述和重大遗漏\nB. 可以刊登独立的第三方机构对基金的推荐性文字\nC. 禁止违规承诺收益，同时也不可以承诺承担亏损\nD. 禁止对证券投资业绩进行预测",
            "answer": "B",
            "explain": "本题考查基金信息披露的禁止行为。基金信息披露的禁止行为包括：(1)虚假记载、误导性陈述或者重大遗漏；(A选项正确) (2)对证券投资业绩进行预测；(D选项正确) (3)违规承诺收益或者承担损失；(C选项正确) (4)诋毁其他基金管理人、基金托管人或者基金销售机构； (5)登载任何自然人、法人或者其他组织的祝贺性、恭维性或推荐性的文字。所以B选项错误。"
        },
        {
            "title": "关于某基金销售机构基金销售适用性相关的制度和程序，以下表述错误的是（　　）。",
            "question": "A. 需要建立普通投资者回访制度\nB. 总部已制定相关制度和程序，需要分支机构再自行制定相关的制度和程序\nC. 需要建立对销售人员进行管理\nD. 需要对所销售产品进行风险评价",
            "answer": "B",
            "explain": "本题考查基金销售适用性与投资者适当性的相关内容。A选项表述正确，基金销售机构应建立健全普通投资者回访制度，对购买一定金额基金产品或者服务的普通投资者定期抽取一定比例进行回访；B选项表述错误，基金销售机构分支机构应当在总部的指导和管理下实施与基金销售适用性相关的制度和程序，而不是再自行制定相关的制度和程序；C选项表述正确，基金销售机构要加强对销售人员的日常管理，建立管理档案，对销售人员行为、诚信、奖惩等方面进行记录 ；D选项表述正确，基金销售机构需要对所销售的产品或者提供的服务进行风险评价。 "
        },
        {
            "title": "互动交流是基金销售机构与投资者深入探讨的重要方式，但其交流内容不包括（　　）。",
            "question": "A. 做好客户回访日志，记录并处理潜在风险隐患、客户建议及意见\nB. 做好客户服务日志及客户资料的更新、完备工作\nC. 向客户传递由基金次日价格走势及最新的投资报告\nD. 深入了解客户的投资需求，确定和记录客户服务标准",
            "answer": "C",
            "explain": "本题考查互动交流的主要内容。基金互动交流是基金销售机构与投资者深入探讨的重要方式，其交流内容如下：(1)深入了解客户的投资需求，确定和记录客户服务标准；(D选项正确) (2)及时向客户传递重要的市场资讯、持仓品种信息及最新的投资报告； (3)做好客户服务日志及客户资料的更新、完备工作；(B选项正确) (4)拟定、组织、实施及评估年(季、月)度客户关怀计划； (5)进行公司所有新客户的首次和定期电话回访工作，改善客户体验，提升满意度 ；(6)做好客户回访日志，记录并处理潜在风险隐患、客户建议及意见。(A选项正确)基金销售机构不能向客户预测基金价格走势，C选项错误。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/flfg-5.js